module.exports = __webpack_public_path__ + "12_hair_black.c9d86f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/12_hair_black.png
// module id = YI6t
// module chunks = 0